{
  "additional_products": "Additional products",
  "apply": "Apply",
  "arriving_at": "Arriving at",
  "available": "Available",
  "available_for_single_use": "Bookable for single use",
  "back": "Back",
  "back_to_payment": "Back to payment",
  "book_now": "Book now",
  "booking_confirmed_text": "Your booking is confirmed.",
  "booking_confirmed_title": "Thank you for booking with us!",
  "cabin_count": "{{ count }} cabins",
  "cabin_count_zero": "Select",
  "cabin_count_one": "{{count }} cabin",
  "cabin_x": "Cabin {{ index }}",
  "chat_button_text": "💬 How can we help?",
  "checkout": "Checkout",
  "choose_preferred_ship": "Choose preferred ship",
  "choose_preferred_ship_one": "Ship",
  "choose_preferred_ship_other": "Choose preferred ship",
  "choose_ship": "Choose ship",
  "chosen_ship": "Chosen ship",
  "close": "Close",
  "creating_your_booking": "Creating your booking",
  "credit_card_extra_charge": "For credit cards outside the EU a 3% transaction fee is added",
  "current_voucher_code": "Code: {{ code}}",
  "date_format": "D‍/‍MMM‍/‍YYYY",
  "date_format_short": "D MMM",
  "date_range": "{{ start }} - {{ end }}",
  "depart_from": "Depart from",
  "departure_date": "Departure date",
  "discount": "Discount",
  "discount_tooltip": "If a date is highlighted in orange, it means there is a discount available for the tour started on that day. Click on the highlighted date to view the details of the discount.",
  "gender_female": "Female",
  "gender_male": "Male",
  "gender_none": "",
  "have_coupon_code": "Coupon code?",
  "insurance": "Insurance",
  "invalid_voucher_code": "Invalid voucher code",
  "loading": "Loading…",
  "max_x_persons_one": "max {{ count }} person",
  "max_x_persons_other": "max {{ count }} persons",
  "next": "Next",
  "no_cabins_available": "No cabins available",
  "no_diet": "No diet",
  "no_ship_available": "No ship available.",
  "number_of_products": "No. of products",
  "on_request": "On request",
  "on_request_tooltip": "\"Available on request\" means we need to double-check availability for several reasons; we'll confirm your booking or propose alternatives within 48 hours.",
  "only_x_left_one": "Only {{ count }} left",
  "only_x_left_other": "Only {{ count }} left",
  "passenger": "Passengers",
  "people_count": "{{ count }} persons",
  "people_count_one": "{{ count }} person",
  "personal_information_additional": "Personal information - Additional passenger {{ index }}",
  "personal_information_main": "Personal information - Main booker",
  "price": "Price",
  "price_overview": "Price overview",
  "price_per_person": "{{ price }} p.p.",
  "price_starting_from": "starting at {{ price }}",
  "prices_and_availability": "Prices & Availability",
  "processing_payment": "Processing payment",
  "product_name": "Product name",
  "read_less": "Read less",
  "read_more": "Read more",
  "remove_coupon_code": "Remove coupon code?",
  "search_for_a_tour": "Search for a tour",
  "select_date": "Please select a date",
  "select_your_cabins": "Please select your cabin(s)",
  "something_went_wrong": "Something went wrong",
  "start_booking": "Start booking",
  "subtotal": "Subtotal",
  "total": "Total",
  "unavailable": "Fully booked",
  "unknown": "Unknown",
  "unsupported_browser_description": "Please update your browser.",
  "unsupported_browser_title": "Your browser is not supported.",
  "vat": "VAT ({{ percentage }}%)",
  "voucher_placeholder": "Coupon code",
  "x_days_one": "{{ count }} day",
  "x_days_other": "{{ count }} days"
}
